var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.selectedCollectionCategory).length > 0)?_c('div',{staticClass:"marketing-banner"},[_c('div',{staticClass:"marketing-banner-img",style:(`--desktop-image: url('${_vm.desktopImg}');
  --tablet-image: url('${_vm.tabletImg}');
  --mobile-image: url('${_vm.mobileImg}')`)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }